import { DEPRECIATION_METHOD_CODE } from 'common/constants'
import { isAccountingJournalTarget } from 'common/helpers'
import { AssetLedger, LedgerSetting } from 'common/models'

export const isLedgerForCalculateRevise = (ledger?: Partial<AssetLedger>) =>
  Boolean(
    [DEPRECIATION_METHOD_CODE.NEW_DECLINING_BALANCE_250, DEPRECIATION_METHOD_CODE.NEW_DECLINING_BALANCE_200].includes(
      Number(ledger?.depreciation_method_code)
    ) &&
    ledger?.ledger_setting_id &&
    ledger?.service_life
  )

export const filterLedgers = (
  ledgers?: Partial<AssetLedger>[],
  accountantLedger?: Partial<AssetLedger>,
  ledgerSettings?: LedgerSetting[]
) => {
  const ledgersForCalculate = (ledgers || [])?.filter(ledger => {
    const isAccountingLedger = isAccountingJournalTarget(
      ledgerSettings?.find(ledgerSetting => ledgerSetting.id === ledger.ledger_setting_id)
    )
    return (
      isLedgerForCalculateRevise(ledger) &&
      (isAccountingLedger ||
        (ledger.depreciation_method_code === accountantLedger?.depreciation_method_code &&
          ledger.service_life === accountantLedger?.service_life &&
          ledger.transition_book_value === accountantLedger?.transition_book_value))
    )
  })

  const ledgersForReset = (ledgers || [])?.filter(ledger => {
    const isAccountingLedger = isAccountingJournalTarget(
      ledgerSettings?.find(ledgerSetting => ledgerSetting.id === ledger.ledger_setting_id)
    )
    return (
      isLedgerForCalculateRevise(ledger) &&
      isLedgerForCalculateRevise(accountantLedger) &&
      !isAccountingLedger &&
      (ledger.depreciation_method_code !== accountantLedger?.depreciation_method_code ||
        ledger.service_life !== accountantLedger?.service_life ||
        ledger.transition_book_value !== accountantLedger?.transition_book_value)
    )
  })

  return { ledgersForCalculate, ledgersForReset }
}
